export const audiomotionanalyzerPresets = [
    {
        name: 'Preset 1',
        value: {
            alphaBars: false,
            ansiBands: false,
            barSpace: 0.7,
            channelLayout: 'single',
            colorMode: 'gradient',
            fadePeaks: true,
            fftSize: 16384,
            fillAlpha: 0,
            frequencyScale: 'log',
            gradient: 'prism',
            gravity: 11,
            ledBars: false,
            linearAmplitude: false,
            linearBoost: 4,
            lineWidth: 1.9,
            loRes: false,
            lumiBars: false,
            maxDecibels: -25,
            maxFPS: 0,
            maxFreq: 22050,
            minDecibels: -85,
            minFreq: 20,
            mirror: 0,
            mode: 10,
            noteLabels: false,
            outlineBars: false,
            peakFadeTime: 900,
            peakHoldTime: 500,
            peakLine: true,
            radial: false,
            radialInvert: false,
            radius: 0.7,
            reflexAlpha: 0.1,
            reflexBright: 1,
            reflexFit: false,
            reflexRatio: 0.5,
            roundBars: false,
            showFPS: false,
            showPeaks: false,
            showScaleX: false,
            showScaleY: false,
            smoothing: 0.6,
            spinSpeed: 0,
            splitGradient: false,
            trueLeds: false,
            volume: 1,
            weightingFilter: '',
        },
    },
    {
        name: 'Preset 2',
        value: {
            alphaBars: false,
            ansiBands: false,
            barSpace: 0.7,
            channelLayout: 'single',
            colorMode: 'gradient',
            fadePeaks: true,
            fftSize: 8192,
            fillAlpha: 1,
            frequencyScale: 'log',
            gradient: 'prism',
            gravity: 11,
            ledBars: true,
            linearAmplitude: false,
            linearBoost: 4,
            lineWidth: 0,
            loRes: false,
            lumiBars: false,
            maxDecibels: -25,
            maxFPS: 0,
            maxFreq: 8000,
            minDecibels: -85,
            minFreq: 20,
            mirror: 0,
            mode: 4,
            noteLabels: false,
            outlineBars: false,
            peakFadeTime: 900,
            peakHoldTime: 500,
            peakLine: true,
            radial: false,
            radialInvert: false,
            radius: 0.7,
            reflexAlpha: 0.5,
            reflexBright: 1,
            reflexFit: false,
            reflexRatio: 0.5,
            roundBars: false,
            showFPS: false,
            showPeaks: false,
            showScaleX: false,
            showScaleY: false,
            smoothing: 0.7,
            spinSpeed: 0.5,
            splitGradient: false,
            trueLeds: false,
            volume: 1,
            weightingFilter: '',
        },
    },
    {
        name: 'Preset 3',
        value: {
            alphaBars: false,
            ansiBands: false,
            barSpace: 0,
            channelLayout: 'single',
            colorMode: 'gradient',
            fadePeaks: true,
            fftSize: 4096,
            fillAlpha: 0,
            frequencyScale: 'log',
            gradient: 'prism',
            gradientLeft: 'rainbow',
            gradientRight: 'prism',
            gravity: 11,
            ledBars: true,
            linearAmplitude: false,
            linearBoost: 4,
            lineWidth: 1.9,
            loRes: false,
            lumiBars: false,
            maxDecibels: -25,
            maxFPS: 0,
            maxFreq: 15000,
            minDecibels: -85,
            minFreq: 20,
            mirror: 0,
            mode: 8,
            noteLabels: false,
            outlineBars: false,
            peakFadeTime: 900,
            peakHoldTime: 500,
            peakLine: true,
            radial: false,
            radialInvert: false,
            radius: 0.7,
            reflexAlpha: 0.45,
            reflexBright: 1,
            reflexFit: false,
            reflexRatio: 0,
            roundBars: false,
            showFPS: false,
            showPeaks: false,
            showScaleX: false,
            showScaleY: false,
            smoothing: 0.8,
            spinSpeed: 0.5,
            splitGradient: false,
            trueLeds: false,
            volume: 1,
            weightingFilter: '',
        },
    },
    {
        name: 'Preset 4',
        value: {
            alphaBars: false,
            ansiBands: false,
            barSpace: 0,
            channelLayout: 'dual-combined',
            colorMode: 'gradient',
            fadePeaks: true,
            fftSize: 16384,
            fillAlpha: 0.2,
            frequencyScale: 'log',
            gradient: 'prism',
            gradientLeft: 'prism',
            gradientRight: 'rainbow',
            gravity: 11,
            ledBars: true,
            linearAmplitude: false,
            linearBoost: 4,
            lineWidth: 1.9,
            loRes: false,
            lumiBars: false,
            maxDecibels: -25,
            maxFPS: 0,
            maxFreq: 22050,
            minDecibels: -85,
            minFreq: 50,
            mirror: 0,
            mode: 10,
            noteLabels: false,
            outlineBars: false,
            peakFadeTime: 900,
            peakHoldTime: 500,
            peakLine: true,
            radial: false,
            radialInvert: false,
            radius: 0.7,
            reflexAlpha: 0.45,
            reflexBright: 1,
            reflexFit: true,
            reflexRatio: 0.2,
            roundBars: false,
            showFPS: false,
            showPeaks: false,
            showScaleX: false,
            showScaleY: false,
            smoothing: 0.8,
            spinSpeed: 0.5,
            splitGradient: false,
            trueLeds: false,
            volume: 1,
            weightingFilter: 'D',
        },
    },
];
